export enum AmplitudeEvent {
	ENGLISH_LANG = 'Lang popup English',
	KURDISH_LANG = 'Lang popup Kurdish',
	ARABIC_LANG = 'Lang popup Arabic',
	PAGE_VIEWED = 'Page Viewed',
	BANNER_AD = 'Banner Ad',
	SHORTCUTS = 'Shortcuts'
}
